/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutAdvanced from '../components/LayoutAdvanced.jsx';
import NavigatorSeries from '../components/NavigatorSeries.jsx';
import Map from '../components/Map.jsx';
import OptionMapSelectorSeries from '../components/OptionMapSelectorSeries.jsx';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import LocalStorage from '../service/LocalStorage';

import i18n from '../resources/i18n.js';
import {properties} from '../resources/properties.js';

import IMG_CARTOGRAFIA_1 from '../img/Carousel/Cartografia/img153.jpg';
import IMG_CARTOGRAFIA_2 from '../img/Carousel/Cartografia/img91_R.jpg';

declare var M;
let plugin = new M.plugin.Mapaalacarta({
  enabled: true, seriesMode: true, minHojas:10, groupOperations: true
});
// const xylocator = new M.plugin.XYLocator();
const ignsearch = new M.plugin.IGNSearch({
  urlFind : properties.urlGeocoder+"/api/geocoder/findJsonp",
  urlCandidates : properties.urlGeocoder+"/api/geocoder/candidatesJsonp", 
  urlReverse : properties.urlGeocoder+"/api/geocoder/reverseGeocode",
  servicesToSearch: "g",
  maxResults: 30,
  noProcess:"expendeduria"
});
const fullviewmap = new M.plugin.FullViewMap({
  position: 'BL',
});
let scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);
const insertPhotoPlugin = new M.plugin.InsertPhoto({
  position: 'BL',
});
const editionTools = new M.plugin.EditionTools({numberOfDrawFeatures: 0, precharged: properties.ROUTE_CATALOGUE_URLS, minScale: properties.MINSCALE});
// xylocator
const pluginList = [plugin, ignsearch, scaleZoomPlugin, fullviewmap, insertPhotoPlugin];

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Step1SS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerX: -417002.20780977904,
      centerY: 4931965.4853014955,
      isTourOpen: false,
      showModalWarningLegend: false
    };
    this.handleShowWarningLegend = this.handleShowWarningLegend.bind(this);
    this.handleCloseWarningLegend = this.handleCloseWarningLegend.bind(this);
    this.handleCloseWarningLegendContinue = this.handleCloseWarningLegendContinue.bind(this);
    window.showWarningLegend = this.handleShowWarningLegend;

    pluginList[0]=plugin;
    //scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);pluginList[3]=scaleZoomPlugin; // Esto parece que causaba perdida de relación con este plugin tras modificar la escala de zoom
    //TestAdminUSER
    let testLogin = LocalStorage.get('login-cookie');// POSIBLEMENTE ES MEJOR MOVERLO FUERA DE AQUí con otro metodo de saber su estado antes de llegar aquí
    if(testLogin && testLogin.fecha > new Date().getTime()){
      this.props.parentState.specialMapGeneration = (testLogin.token === properties.TOKEN);
    }else{
      LocalStorage.delete('login-cookie');
      this.props.parentState.specialMapGeneration = false;
      if(this.props.parentState.serImgC){
        this.props.parentState.serImgC.forEach((h)=>{
          delete h.nipo;
          delete h.isbn;
          delete h.depositoLegal;
          delete h.codigoBarras;
          delete h.realCodigoBarras;
          delete h.specialFileName;
        });
      }
    }
    testLogin = null;
    //TestAdminUSER
  }

  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }

  setModal = (mapa, state) => {
    const {setModal} = this.props;
    setModal(mapa, state);
  }

  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  setMapa = (map) => {
    let {parentState} = this.props;
    parentState.mapa = map;
    this.setStateGlobal(parentState);
  };

  convertScaleValueToScaleFactor(scaleValue) {
    var scaleFactor = 0;
    switch (scaleValue) {
      case '1:2.500':
        scaleFactor = 2.5;
        break;
      case '1:5.000':
        scaleFactor = 5;
        break;
      case '1:10.000':
        scaleFactor = 10;
        break;
      case '1:25.000':
        scaleFactor = 25;
        break;
      case '1:30.000':
        scaleFactor = 30;
        break;
      case '1:20.000':
        scaleFactor = 20;
        break;
      case '1:40.000':
        scaleFactor = 40;
        break;
      case '1:50.000':
        scaleFactor = 50;
        break;
      case '1:60.000':
        scaleFactor = 60;
        break;
      default:
        scaleFactor = 2.5;
    }

    return scaleFactor;
  }

  setScaleValue = (event) => {
    let {parentState} = this.props;
    parentState.scale = event;
    this.setStateGlobal(parentState);
    switch (event) {
      case '1:2.500':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '2.5K';
        parentState.scaleCm = '25 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 2.5);
        parentState.previousScale = event;
        parentState.zoom = 15;
        break;
      case '1:5.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '5K';
        parentState.scaleCm = '50 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 5);
        parentState.previousScale = event;
        parentState.zoom = 14;
        break;
      case '1:10.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '10K';
        parentState.scaleCm = '100 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 10);
        parentState.previousScale = event;
        parentState.zoom = 13;
        break;
      case '1:25.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '25K';
        parentState.scaleCm = '250 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 25);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:30.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '30K';
        parentState.scaleCm = '300 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 30);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:20.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '20K';
        parentState.scaleCm = '200 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 20);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:50.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '50K';
        parentState.scaleCm = '500 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 50);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:40.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '40K';
        parentState.scaleCm = '400 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 40);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      default:
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '60K';
        parentState.scaleCm = '600 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 60);
        parentState.previousScale = event;
        parentState.zoom = 10;
        break;
    }

    this.setStateGlobal(parentState);
    if(window.mapJs.getZoom()<parentState.zoom){
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);//plugin.setMapCenter(parentState.mapa);
    }

    // actualizar escala del plugin insertPhoto
    const scaleDenominator = parseFloat(event.replace('1:', '').replace('.', ''));
    insertPhotoPlugin.updateScale(scaleDenominator);

    return parentState.scale;
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  setOrientation = (event) => {
    let {parentState} = this.props;
    if (parentState.previousOrientation !== parentState.orientation) {
      plugin.rotate(event);
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
      parentState.orientation = event;
      if(parentState.verticalCartela){
        if(parentState.image.endsWith(".jpg")){
          if(parentState.serImgC){
            parentState.serImgC.forEach(e => {
              e.image= IMG_CARTOGRAFIA_2;
              e.imageName = 'img91_R.jpg';
            });
          }
        }
      }else{
        if(parentState.image.endsWith(".jpg")){
          if(parentState.serImgC){
            parentState.serImgC.forEach(e => {
              e.image= IMG_CARTOGRAFIA_1;
              e.imageName = 'img91.jpg';
            });
          }
        }
      }
      //this.setStateGlobal(parentState);
    }
    this.setStateGlobal(parentState);
  }

  setVertical = (state) =>{
    let {parentState} = this.props;
    if(state){
      if(parentState.image.endsWith(".jpg")){
        if(parentState.serImgC){
          parentState.serImgC.forEach(e => {
            e.image= IMG_CARTOGRAFIA_2;
            e.imageName = 'img91_R.jpg';
          });
        }
      }
    }else{
      if(parentState.image.endsWith(".jpg")){
        if(parentState.serImgC){
          parentState.serImgC.forEach(e => {
            e.image= IMG_CARTOGRAFIA_1;
            e.imageName = 'img91.jpg';
          });
        }
      }
    }
    this.setStateGlobal(parentState);
  }

  setLegend = (enable) => {
    let {parentState} = this.props;
    if (parentState.previousPosterLegend !== parentState.posterLegend) {
      plugin.changeLegendGeometry(enable);
      //plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
      parentState.posterLegend = enable;
    }
    this.setStateGlobal(parentState);
  }

  setPluginMALC(obtained) {
    plugin = obtained;
    pluginList[0]=plugin;//update al array de plugins.
  }

  handleShowWarningLegend() {
    this.props.parentState.numberId = editionTools.getNumberOfIdFeature();//update del numberId
    this.setState({showModalWarningLegend: true});
  }
  handleCloseWarningLegend() {
    this.setState({showModalWarningLegend: false});
    const drawLegend = document.querySelector('div.m-control.m-addlegend-container');
    if (drawLegend.classList.contains('activated')) {
      drawLegend.children[0].click();
    }
  }
  handleCloseWarningLegendContinue(){
    this.setState({showModalWarningLegend: false});
    editionTools.toggleLegendMenu();
  }
  componentWillUnmount(){
    window.showWarningLegend = null;
  }

  render() {
    const {centerX, centerY, isTourOpen} = this.state;
    const {parentState} = this.props;

    const tablistState = document.getElementsByClassName('TabsList')[0];
    const stateOptions = tablistState ? tablistState.children[0].className === "tabsOption activeTabs": true;

    const steps = [
      {
        selector: '.TabsList',
        content: i18n.t('tour.seriesOptionsStep1'),
      },
      stateOptions ? {
        selector: '.product-step',
        content: i18n.t('tour.productStep1'),
      }:undefined,
      stateOptions ? (parentState.seleccionadoProductoSeries === 'Foto'? {
        selector: '.first-step',
        content: i18n.t('tour.step1FirstStepPhoto'),
      }:{
        selector: '.first-step',
        content: i18n.t('tour.step1FirstStepSeries'),
      }):undefined,
      stateOptions && parentState.seleccionadoProductoSeries !== 'Foto'?{
        selector: '.showGridHelp',
        content: i18n.t('tour.mapHelpStep1'),
      }:undefined,
      stateOptions ? (parentState.seleccionadoProductoSeries === 'Foto'? {
        selector: '.second-step',
        content: i18n.t('tour.step1SecondStepFoto'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      }:{
        selector: '.second-step',
        content: i18n.t('tour.step1SecondStep'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      }):undefined,
      stateOptions ? {
        selector: '.third-step',
        content: i18n.t('tour.step1ThirdStep'),
      }:undefined,
      stateOptions && parentState.seleccionadoProductoSeries === 'Poster'?{
        selector: '.applyLegend',
        content: i18n.t('tour.checkboxLegendStep1'),
      }:undefined,
      stateOptions && parentState.seleccionadoProductoSeries === 'Elaborado'?{
        selector: '.cartela-step',
        content: i18n.t('tour.cartelaStep1'),
      }:undefined,
      stateOptions ? {
        selector: '.fourth-step',
        content: i18n.t('tour.step1FourthStep'),
      }:undefined,
      stateOptions ? {
        selector: '.fifth-step',
        content: i18n.t('tour.step1FifthStep'),
      }:undefined,
      !stateOptions ? {
        selector: '.simpleFlex.g-cartografia-mas',
        content: i18n.t('tour.hojaAddStep1'),
      }:undefined,
      !stateOptions ? {
        selector: '.listSheetStyle',
        content: i18n.t('tour.listHojaStep1'),
      }:undefined,
      !stateOptions ? {
        selector: '.simpleFlex.g-cartografia-mano2',
        content: i18n.t('tour.focusHojaStep1'),
      }:undefined,
      !stateOptions ? {
        selector: '.simpleFlex.editiontools-papelera',
        content: i18n.t('tour.deleteHojaStep1'),
      }:undefined,
      {
        selector: '.search-panel',
        content: i18n.t('tour.step1SixthStep'),
      },
      {
        selector: '.m-xylocator',
        content: i18n.t('tour.step1SeventhStep'),
      },
      {
        selector: '.m-scalezoom',
        content: i18n.t('tour.step1TenthStep'),
      },
      {
        selector: '#container-button2',
        content: i18n.t('tour.step1EleventhStep'),
      },
      {
        selector: '.m-plugin-fullviewmap',
        content: i18n.t('tour.step1EighthStep'),
      },
      {
        selector: '#m-insertPhoto-btn',
        content: i18n.t('tour.step1TwelveStep'),
      },
      {
        selector: '.m-tools-editionTools',
        content: i18n.t('tour.step1NinthStep'),
      },
      {
        selector: '#m-button-drawFeature',
        content: i18n.t('tour.step1NinthPointTwoStep'),
      },
      {
        selector: '#m-button-drawFeature2',
        content: i18n.t('tour.step1NinthPointThreeStep'),
      },
      {
        selector: '#m-button-drawFeature3',
        content: i18n.t('tour.step1NinthPointFourStep'),
      },
      {
        selector: '#m-button-drawFeature5',
        content: i18n.t('tour.step1NinthPointFiveStep'),
      },
      {
        selector: '#m-button-addprecharged',
        content: i18n.t('tour.step1NinthPointNineStep'),
      },
      {
        selector: '#m-button-locallayers',
        content: i18n.t('tour.step1NinthPointOneStep'),
      },
      {
        selector: '#m-button-addlegend',
        content: i18n.t('tour.step1AddLegend'),
      },
      {
        selector: '#m-button-pickfeature',
        content: i18n.t('tour.step1NinthPointFiveTwoStep'),
      },
      {
        selector: '#m-button-moveFeature',
        content: i18n.t('tour.step1NinthPointSixStep'),
      },
      {
        selector: '#m-button-editFeature',
        content: i18n.t('tour.step1NinthPointSevenStep'),
      },
      {
        selector: '#m-button-deleteFeature',
        content: i18n.t('tour.step1NinthPointEightStep'),
      },
      {
        selector: '#m-button-downloadLayer',
        content: i18n.t('tour.step1NinthPointTenStep'),
      },
      {
        selector: '#m-button-undoFeature',
        content: i18n.t('tour.step1NinthPointElevenStep'),
      }
    ].filter(Boolean);

    editionTools.setNumberOfIdFeature(parentState.numberId);
    scaleZoomPlugin.setState(parentState);
    scaleZoomPlugin.setCallbackState(this.setStateGlobal);

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar';
    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step1'
    const sectionClassName = 's1-left';
    const asideClassName = 's1-right';

    //Next and previous pages
    const nextPage = '/Step2';
    const previousPage = '/main';

    return (<React.Fragment>
      <LayoutAdvanced setParentStateSteps={this.setStateGlobalStep} parentState={parentState} inforCoords={parentState.inforFeatureCoordinates} label={null} activeRow={this.props.activeRow} nextPage={nextPage} previousPage={previousPage} isStep3={0}>
        <Dialog open={this.state.showModalWarningLegend} onClose={this.handleCloseWarningLegend} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.generateLegend">
              Generar leyenda
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.generateLegendWarning">
              Se recomienda configurar la leyenda solo tras finalizar el añadido y estilado de todas las demás entidades del mapa.
            </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegendContinue}>
              <Trans i18nKey="dialog.continue">CONTINUAR</Trans>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegend}>
              <Trans i18nKey="dialog.cancel">CANCELAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <NavigatorSeries leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorSeries>
        <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={this.closeTour} />
        <h1>
          <i className="mc-design"></i>
          <label>
          <Trans i18nKey="step1.mapDesign">
            Diseño del mapa
          </Trans>
          </label>
        </h1>
        <div className={stepClassName}>
          <section className={sectionClassName}>
            <div className="fifth-step">
              <Map setModal={this.setModal} setParentState={this.setStateGlobal} location={this.props.location} pluginEdition={editionTools} activeServices={parentState.activeServices} parentState={parentState} pluginList={pluginList} M={M} centerX={centerX} centerY={centerY} mapa={this.setMapa} isSimple={false} baseLayer='BOTH'></Map>
            </div>
            <br/>
            <a onClick={this.openTour}>
              <label id="download-tui-image" className="inputfile generalHelpButton">
                <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
              </label>
            </a>
          </section>
          <OptionMapSelectorSeries setParentState={this.setStateGlobal} parentState={parentState} actionScale={this.setScaleValue} actionOrientation={this.setOrientation} actionLegendPoster={this.setLegend} refreshPlugin={this.setPluginMALC} actionVertical={this.setVertical} scaleValueChild={parentState.scale} activeRow={this.props.activeRow} asideClassName={asideClassName} classPanelButton='panel-button' classPanelContent='panel-content' pluginEdition={editionTools}/>
        </div>
      </LayoutAdvanced>
    </React.Fragment>);
  }
}

export default Step1SS;
